import React from "react";
import {Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";
import { deleteOrder,fetchOrders } from "appRedux/actions/Orders";

class ModalDelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    }
    }

    showModal = () => {
      this.setState({
        visible: true,
      });
    };

 

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El producto se ha eliminado con éxito.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al eliminar el producto.',
      });
    }
  };
  
 
  render() {

    return (
      <div>
        <Button type="danger" onClick={this.showModal}><i className="icon icon-trash"/></Button>
        <Modal
          okText = "Borrar"
          cancelText = "Salir"
            title="Borrar"
            visible={this.state.visible}
            onOk={() => {
              //console.log(this.props.recording.id);
              this.props.deleteOrder(this.props.recording.id);
              this.props.fetchOrders(this.props.dataState);
              this.onNotification('success');
            }}
            onCancel={() => {
              this.props.fetchOrders(this.props.dataState)
              this.setState({visible: false});
            }}
          >
          <p>Está seguro de cancelar la orden de {this.props.recording.name}?</p>
        </Modal>
      </div>
    );
  }
}


function mapStateToProps({products}) {
  return {
    products
  }
}
export default connect(mapStateToProps, {fetchOrders, deleteOrder} )(ModalDelete);


// WEBPACK FOOTER //
// ./src/routes/main/Orders/ModalDelete.js